import type { SidebarTab } from "@helm/core";

/** Open a right-sidebar tab from anywhere (top toolbar Alert button, palette). */
const EVENT = "helm:open-sidebar-tab";

export function openSidebarTab(tab: SidebarTab): void {
  window.dispatchEvent(new CustomEvent<SidebarTab>(EVENT, { detail: tab }));
}

export function onOpenSidebarTab(cb: (tab: SidebarTab) => void): () => void {
  const h = (e: Event): void => {
    cb((e as CustomEvent<SidebarTab>).detail);
  };
  window.addEventListener(EVENT, h);
  return () => {
    window.removeEventListener(EVENT, h);
  };
}
